const translations = {
    unit: 'Unit',
    unitIsRequired: 'Unit is required'
};

export default translations;
